export enum EStripePaymentIntentStatus {
  RequiresPaymentMethod = "requires_payment_method",
  RequiresConfirmation = "requires_confirmation",
  RequiresAction = "requires_action",
  RequiresCapture = "requires_capture",
  Processing = "processing",
  Succeeded = "succeeded",
  Canceled = "canceled",
}
